String.prototype.capitalize = function() {
    return this[0].toUpperCase() + this.substring(1);
};

export default string =>
    string
        .split('_')
        .map(it => it.toLowerCase())
        .join(' ')
        .capitalize();
